import { connect } from 'react-redux';
import Modal from 'comp/modals/change_name';
import { cache } from 'utils';

const mapToProps = state => ({
  status: state.fetch.user_change_name || cache.empty_obj,
  user: state.user
});

export default connect(mapToProps)(Modal);



// WEBPACK FOOTER //
// ./src/containers/modals/ChangeName.js